import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable ,  of } from 'rxjs';
import { Payment } from '../../fiscal/models/payment.model';
import {
  PaymentMethod,
  PayPointReturnCode
} from '../../fiscal/fiscal.constants';
import { FormShareService } from '../services/share.service';

@Injectable()
export class FormConfirmationResolver implements Resolve<Payment> {
  constructor(private formService: FormShareService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Payment> {
    if (this.queryParamsHasConfirmationData(route.queryParams)) {
      this.formService.formNewPayment = this.createPaymentFromPayPoint(
        route.queryParams
      );
      return of(this.formService.formNewPayment);
    }

    return of(null);
  }

  // This is used to store all query string parameters required by the API
  private createPaymentFromPayPoint(responseParams: {
    [key: string]: any;
  }): Payment {
    const payment = new Payment();

    // Set payment type to be eCheck. It should be overwritten if "ct" was returned, it is only present when credit card was processed
    payment.paymentMethod = PaymentMethod.ECheck;

    // Capture response url from PayPoint
    payment.responseUrl = window.location.href;

    // Return URL assigning to payment object
    for (const key in responseParams) {
      if (key === 'i') {
        payment.id = responseParams[key];
      } else if (key === 'c') {
        if (responseParams[key] in PayPointReturnCode) {
          // The code comes in as a string from the URL query string and it has a corresponding enum value in PayPointReturnCode
          // The following lines convert the string enum value properly to the strongly typed enum value
          const codeString: string = responseParams[key];
          const codeName: string = PayPointReturnCode[codeString]; // Use the code string to get the enum name from the enum
          payment.returnCode = PayPointReturnCode[codeName]; // Use the enum's code name to get the enum value
        }
      } else if (key === 'm') {
        payment.returnMessage = responseParams[key];
      } else if (key === 'o') {
        payment.confirmationNumber = responseParams[key];
      } else if (key === 't') {
        payment.totalPaidAmount = responseParams[key];
      } else if (key === 'd') {
        payment.settlementSubmissionDate = new Date(responseParams[key]);
      } else if (key === 'hash') {
        payment.hash = responseParams[key];
      } else if (key === 'ct' && responseParams[key] !== '') {
        payment.paymentMethod = PaymentMethod.CreditCard;
      }
    }

    // Added business logic -- since credit card payments don't really have a real "settlement submission date"...
    // Set the settlementSubmissionDate to now instead of PayPoint's date
    // -- This fixes issue where when payments are submitted at night, the date given to us from PayPoint is the next day
    if (payment.paymentMethod === PaymentMethod.CreditCard) {
      payment.settlementSubmissionDate = new Date();
    }

    return payment;
  }

  private queryParamsHasConfirmationData(queryParams: {
    [key: string]: any;
  }): boolean {
    if (!queryParams['i'] || !queryParams['c']) {
      return false;
    }

    return true;
  }
}
